export enum TestUser {
    AGNI = "AGNI", // manager
    ARYA = "ARYA", // employee 1
    TEJAS = "TEJAS", // employee 2
    NYX = "NYX", // employee 2
    HYPER = "HYPER",
    Melhem = "Melhem", // employee

    // swapping test emp
    // manager = EDUARD
    // emp = DANIEL, DAVID
    PACE_SUPERADMIN = "PACE_SUPERADMIN",
    PACE_DANIEL = "PACE_DANIEL",
    PACE_DAVID = "PACE_DAVID",
    PACE_EDUARD = "PACE_EDUARD",
    PACE_YURI = "PACE_YURI",
    PACE_MARKO = "PACE_MARKO",
    PACE_MARTIN = "PACE_MARTIN",
    PACE_MICHAIL = "PACE_MICHAIL",
    PACE_MILOS = "PACE_MILOS",
    PACE_NIKOLA = "PACE_NIKOLA",
    PACE_SHAWN = "PACE_SHAWN",
    // swapping test emp

    // nextgen
    NGW_OFC = "NGW_OFC",

    // nextgen dev
    ARVIND_MANAGER = "ARVIND_MANAGER",
    QA_APPROVER = "QA_APPROVER", // superadmin
    QA_BHAVESH = "QA_BHAVESH",
    QA_NEHA = "QA_NEHA",
    QA_RAHUL = "QA_RAHUL",
    CustomRule = "CustomRule",
    Pariswork = "Pariswork",

    // vishweshshukla dev acc
    LEVELONE_EMPONE = "LEVELONE_EMPONE",

    QALAYFORD = "QALAYFORD",
}

export const TestTokenProvider = (user: TestUser) => {
    //
    switch (user) {
        case TestUser.Melhem:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NzU0IiwidXNlcl9hY2NvdW50X2lkIjoiMTc0NDAyMTc4NSJ9.WvULLz1P4gIHYSxSQHivkiHvyB0spM-M1g-PkXD27do";
        case TestUser.AGNI:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0ODg1IiwidXNlcl9hY2NvdW50X2lkIjoiMTczNTIwODAxOSJ9.jBoDrVfDL6peYUyymcGbeXmRos8TFxsjI01WZrqU4FE";

        case TestUser.TEJAS:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzM1MjA4MDE5IiwibG9nZ2VkaW5faWQiOiI1NDg4NCJ9.0KYJnYE-zDltq0gW5389b6jrIwuoW9M-XN5I4Z3jynE";

        case TestUser.ARYA:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNjY3Mjg2ODAzIiwibG9nZ2VkaW5faWQiOiI0MzA4NyJ9.jmLAEVepjZxX-dQbL4FArx2iBz6y0A2n8NEFE956RMg";

        case TestUser.NYX:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NDg5IiwidXNlcl9hY2NvdW50X2lkIjoiMTczNTIwODAxOSJ9.RyyN8WbNi9SLoWKaR_x3cQZmkx7CwZkPv27XFp0xvMs";

        case TestUser.HYPER:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NDkwIiwidXNlcl9hY2NvdW50X2lkIjoiMTczNTIwODAxOSJ9.32gjSxXIVoRWNMHCbk9tDQdUACmZdNgKu0abTBsq6Ac";

        case TestUser.PACE_DANIEL:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzIwMDg1NDQwIiwibG9nZ2VkaW5faWQiOiI1NDcwMyJ9.AVgtnKblkBTc4y3wYXfId3pdAW9D9UGpbx7T3U2HiKA";

        case TestUser.PACE_DAVID:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQ3IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.UnBmU4tdHj7i5ItLnfQ4hYN7ZMWnvdX-Ti88Tiqgp-0";

        case TestUser.PACE_EDUARD:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQyIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.8_JyMHR1dsilGjCljLrgPmLEvpEkJ8Gl9VReqi50DK0";

        case TestUser.PACE_YURI:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NjkzIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.8GvoZzHq7_iVkxnZOJn2lsJPYHUpsmnFjYPh0Hi0W44";

        case TestUser.PACE_MARKO:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQ0IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.pP_6AOFQV0FkOyH7f3VZYAm92qSONpmegjb0t8PLuY8";

        case TestUser.PACE_MARTIN:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzIwMDg1NDQwIiwibG9nZ2VkaW5faWQiOiI1MzY0NiJ9.jPcZBxfa1VMEpoXbhsN1NARVw2Q-APSFglDNsX7f1gk";

        case TestUser.PACE_MICHAIL:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzE3IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.JbAOBZnjcclpKbNYKi5wphqko7yDOKOYB8wIGt6yY-A";

        case TestUser.PACE_MILOS:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzE1IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.g1dr_z3d0D2WpTh8RS_-V2RsQNpNy5oDZItAIgQslzs";

        case TestUser.PACE_NIKOLA:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzAyIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.1Vw2-ckZH0kqlfjeNvzA9UgXUndN0aHOJgWV0T7WvOI";

        case TestUser.PACE_SHAWN:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU0NzA1IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMDA4NTQ0MCJ9.OY82-5171KybxIjGPuSni7Vwjqu1PkjOLuwWwdjwkw4";

        case TestUser.NGW_OFC:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzMxMzg5NzE5IiwibG9nZ2VkaW5faWQiOiIxNzMxMzg5NzE5In0.MJULPsme2RPe72NMEmTh2BKoh5-QrFI0dmtMD0Yw1GI";

        case TestUser.ARVIND_MANAGER:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjY0NjI3IiwidXNlcl9hY2NvdW50X2lkIjoiMTc3MDk2NDQ5MiJ9.5CqtZEvLMwTlp1RD2kVo0RVw8Sc1KoLi6t7wHtc6xn4";

        case TestUser.QA_APPROVER:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjE3MjE5NzYwMzEiLCJ1c2VyX2FjY291bnRfaWQiOiIxNzIxOTc2MDMxIn0.lZm9U4JDwtAu5-Uv8IqAsZemXwdBO7jPlkVCt14OmlQ";

        case TestUser.QA_BHAVESH:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjU1NDk3IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMTk3NjAzMSJ9.vW5xViCizkirYcmRNgrdd3qgk9pzElHhZENB1fwCzh8";

        case TestUser.QA_NEHA:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjQ5IiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMTk3NjAzMSJ9.ohw6tqsdBybFQelkFIHBbcqtR2OfNBCz1qr7hfEA0GA";

        case TestUser.QA_RAHUL:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjUzNjUwIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyMTk3NjAzMSJ9.Rk_1xLiooE8642HTvet4l7XoZwmCy1PVq5xRYV3_fPE";

        case TestUser.PACE_SUPERADMIN:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2FjY291bnRfaWQiOiIxNzIwMDg1NDQwIiwibG9nZ2VkaW5faWQiOiIxNzIwMDg1NDQwIn0.iLZjyUxSURRq3oz1oZvOfDMR07zJjeoFANmyjxGFaiY";

        case TestUser.CustomRule:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjY1MDMyIiwidXNlcl9hY2NvdW50X2lkIjoiMTcyNDkyNjkxMSJ9.DVuKAawSJGtav4at1pGcFmxOEk0Wn4QAVKrtT3jhWqg";

        case TestUser.Pariswork:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjY0NjU1IiwidXNlcl9hY2NvdW50X2lkIjoiMTc3MDcwMTg2MSJ9.lLoqyre_6XjJ5cylLbvMsZfutSCpw4b83OmSs1F6gRU";

        case TestUser.LEVELONE_EMPONE:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjY0NjQwIiwidXNlcl9hY2NvdW50X2lkIjoiMTc3MTIzNTk2MCJ9.GglA-jCh9vJ3r_qHp7pdnvX6Y5CgRs3tfoW60U4lH_I";
        case TestUser.QALAYFORD:
            return "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJsb2dnZWRpbl9pZCI6IjY0NjI2IiwidXNlcl9hY2NvdW50X2lkIjoiMTc3MDcwMTg2MSJ9.s3A3mbZfNsKTNRLScyxso_Yv5DE-6vAYmoPk49HcSLs";
    }
};

export const getRandomOptionalValue = <T>(value: T): T | null | undefined => {
    const randomValue = Math.random();

    if (randomValue < 0.33) {
        return undefined;
    } else if (randomValue < 0.66) {
        return null;
    } else {
        return value;
    }
};
